import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { installErrorCapture } from './lib/errors'
import { installDebugLog } from './lib/debuglog'
import './index.css'

// Installed FIRST, before anything else can throw. An error during boot is
// exactly the one worth capturing, and it is the one a later install misses.
installErrorCapture()
// Second, so the console tee is in place before anything else logs. The run-up
// to a failure is usually where the answer is.
installDebugLog()

/*
 * The service worker asks for the subscription id over a MessagePort, because a
 * worker cannot read localStorage. Registered here so the answer is available as
 * soon as a tab is open.
 */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {
    // No service worker means no push. The app still works; the inbox still works.
  })
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'subscriptionId') {
      event.ports[0]?.postMessage(localStorage.getItem('subscriptionId'))
    }
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
